import UdeskLocales from 'UdeskLocales';
import React, { FC, memo } from 'react';
import { Input, Radio } from 'udesk-ui';

export const AgentTyoeMap = {
    Belong: 1,
    None: 2,
    Email: 3,
};

interface TemplateProps {
    value?: {
        agentType?: number;
        agentEmail?: string;
        title?: string;
    };
    onChange?: (v?: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    return (
        <>
            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    {/* 受理客服 */}
                    {
                        UdeskLocales['current'].components.massagePushConfiguration.otherPush
                            .components.ticketConfig.index.acceptCustomerService
                    }
                </div>
                <div className="massage-push-configuration-row-content">
                    <Radio.Group
                        options={[
                            {
                                label: /* 所属客服 */ UdeskLocales['current'].components
                                    .massagePushConfiguration.otherPush.components.ticketConfig
                                    .index.customerService,
                                value: AgentTyoeMap.Belong,
                            },
                            {
                                label: /* 不设置受理客服 */ UdeskLocales['current'].components
                                    .massagePushConfiguration.otherPush.components.ticketConfig
                                    .index.dontSetUpAcceptCustomerService,
                                value: AgentTyoeMap.None,
                            },
                            {
                                label: /* 指定邮箱 */ UdeskLocales['current'].components
                                    .massagePushConfiguration.otherPush.components.ticketConfig
                                    .index.specifyMailbox,
                                value: AgentTyoeMap.Email,
                            },
                        ]}
                        value={value?.agentType}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                agentType: e.target.value,
                            })
                        }
                    />
                </div>
            </div>

            {value?.agentType === AgentTyoeMap.Email ? (
                <div className="massage-push-configuration-row">
                    <div className="massage-push-configuration-row-label">
                        {/* 指定邮箱 */}
                        {
                            UdeskLocales['current'].components.massagePushConfiguration.otherPush
                                .components.ticketConfig.index.specifyMailbox
                        }
                    </div>
                    <div className="massage-push-configuration-row-content">
                        <Input
                            maxCount={200}
                            value={value?.agentEmail}
                            onChange={(e) =>
                                onChange?.({
                                    ...value,
                                    agentEmail: e.target.value,
                                })
                            }
                            placeholder={
                                /* 请输入受理客服邮箱，仅支持输入一个。 */ UdeskLocales['current']
                                    .components.massagePushConfiguration.otherPush.components
                                    .ticketConfig.index
                                    .pleaseEnterTheAcceptanceCustomerServiceEmailOnlyOneIsSupported
                            }
                        />
                    </div>
                </div>
            ) : null}

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    {/* 工单标题 */}
                    {
                        UdeskLocales['current'].components.massagePushConfiguration.otherPush
                            .components.ticketConfig.index.workOrderTitle
                    }
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        maxCount={200}
                        value={value?.title}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                title: e.target.value,
                            })
                        }
                    />
                </div>
            </div>
        </>
    );
});

export default Template;
